import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    seqPonto: 0,
    modelos: [],
    modeloAtual: {},
    info: "",
    timer: 0,
    empresa: "",
    usuario: "",
    password: "",
    enderecoAPI: "",
    date: "",
    machineLabel: 2, // 1 - COD / 2 - DSC / 3 - COD + DSC
    pieceLabel: 3,
    fake: true
  },
  mutations: {
    cadastraPonto(state, { seqPonto, modelos }) {
      //Atribui seq modelos do ponto e seta o primeiro modelo
      state.seqPonto = seqPonto;
      state.modelos = modelos;
      state.modeloAtual = modelos[0];
    },
    mudarModelo(state, proximoModelo) {
      //Muda o modeloAtual
      state.modeloAtual = proximoModelo;
    },
    gravarInfo(state, { info }) {
      state.info = info;
    },
    gravarTimer(state, { timer }) {
      state.timer = timer;
    },
    gravarDate(state, { date }) {
      state.date = date;
    },
    getContext(state, { empresa, usuario, password, enderecoAPI }) {
      state.empresa = empresa;
      state.usuario = usuario;
      state.password = password;
      state.enderecoAPI = enderecoAPI;
    }
  },
  actions: {},
  modules: {}
});
